"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    reviewBadgeVariants: ()=>reviewBadgeVariants,
    reviewBadgeSizes: ()=>reviewBadgeSizes
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const reviewBadgeVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        badgeSlot: 'bg-customer-8 inline-flex items-center justify-center antialiased transition',
        textSlot: 'text-customer-1 font-bold text-center'
    },
    variants: {
        size: {
            xs: {
                badgeSlot: 'w-7 h-4 pl-[1px] rounded-tl-md rounded-bl-md rounded-tr-sm rounded-br-xsm',
                textSlot: 'text-body3'
            },
            sm: {
                badgeSlot: 'w-8 h-5 pl-[1px] rounded-tl-lg rounded-bl-lg rounded-tr-md rounded-br-xsm',
                textSlot: 'text-heading6'
            },
            md: {
                badgeSlot: 'w-10 h-6 pl-[2px] rounded-tl-lg rounded-bl-lg rounded-tr-md rounded-br-sm',
                textSlot: 'text-heading5'
            },
            lg: {
                badgeSlot: 'w-13 h-8 pl-[2px] rounded-tl-xl rounded-bl-xl rounded-tr-lg rounded-br-sm',
                textSlot: 'text-heading4'
            }
        }
    },
    defaultVariants: {
        size: 'md'
    }
});
const reviewBadgeSizes = Object.keys(reviewBadgeVariants.variants.size);
exports.reviewBadgeSizes = __webpack_exports__.reviewBadgeSizes;
exports.reviewBadgeVariants = __webpack_exports__.reviewBadgeVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "reviewBadgeSizes",
    "reviewBadgeVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
